import type { WatchlistItem } from '@/hooks/useWatchlist';
import { useWatchlistPeriod } from '../../hooks/useWatchlistPeriod';

export function useCompanyPeriodReturn(company: WatchlistItem['company']) {
  const [period] = useWatchlistPeriod();

  if (period === '1M') {
    return { period, return: company.analysisValue.return30d };
  }

  if (period === '3M') {
    return { period, return: company.analysisValue.return90d };
  }

  if (period === '1Y') {
    return { period, return: company.analysisValue.return1yAbs };
  }

  return { period, return: null };
}
